import DialogContent from "@material-ui/core/DialogContent";
import { MapperType, MapperTypeCompanyLevel } from "entities/MapperType";
import { SplitOrdersType } from "entities/SplitOrdersType";
import React, { useEffect } from "react";
import { TextInput, required } from "react-admin";
import { useForm, useFormState } from "react-final-form";

import { PassProps } from "../../../components/_helpers/PassProps";
import { GridForm, GridInput } from "../../../components/GridForm";
import { MapperTypeSelect } from "../../../components/inputs/MapperTypeSelect";
import { getRequiredKeysByType, predefinedByType } from "../../../utils/mapper";
import {
	MapperDataInput,
	MapperDataInputPredefined,
	MapperSettingsInputPredefined,
} from "../../mappers/components/MapperDataInput";

export const AddEditMapperBody = ({ form, orderImportCustomFields, ...rest }) => {
	const [isPredefined, setIsPredefined] = React.useState(false);
	const [requiredKeys, setRequiredKeys] = React.useState();
	const { values } = useFormState();

	useEffect(() => {
		const predefinedData = predefinedByType[values["type"]]
			? [...predefinedByType[values["type"]]]
			: null;
		if (values["type"] === MapperType.order_import && rest?.company_id && orderImportCustomFields) {
			const existingKeys = Object.keys(predefinedData).map((k) => parseInt(k, 10));
			const lastIndex = existingKeys.length ? Math.max(...existingKeys) : -1;
			let i = lastIndex + 1;

			orderImportCustomFields.forEach((field) => {
				const alreadyExists = Object.values(predefinedData).some(
					(entry) => entry.key === field.name
				);
				if (!alreadyExists) {
					predefinedData[i.toString()] = {
						key: field.key,
						value: "",
					};
					i++;
				}
			});
		}
		const predefinedSettings = [
			{
				key: "order_import_split_orders_type",
				value: SplitOrdersType.not_split,
				is_show_on_import: true,
			},
			{ key: "is_order_import_add_loading_sequence_to_ref", value: false, is_show_on_import: true },
			{ key: "is_order_import_attach_source_doc", value: true, is_show_on_import: true },
			{ key: "is_order_import_split_document_content", value: true, is_show_on_import: true },
			{ key: "is_order_import_generate_pallets", value: false, is_show_on_import: true },
		];
		if (predefinedData) {
			if (!rest?.record?.data) {
				form.change("data", predefinedData);
				if (values["type"] === MapperTypeCompanyLevel.order_import) {
					form.change("settings", predefinedSettings);
				}
			}
			setIsPredefined(true);
		} else {
			form.change("data", []);
			form.change("settings", []);
			setIsPredefined(false);
		}
		const requiredKeys = getRequiredKeysByType(values["type"]);
		setRequiredKeys(requiredKeys);
	}, [values["type"]]);

	return (
		<PassProps
			component={DialogContent}
			childPropKeys={["resource", "record"]}
			resource="customer-companies-mappers"
			{...rest}
		>
			<GridForm>
				<GridInput
					xs={6}
					component={TextInput}
					source="name"
					label="resources.mappers.fields.name"
					validate={required()}
				/>
				<GridInput
					xs={6}
					component={MapperTypeSelect}
					source="type"
					label="resources.mappers.fields.type"
					enumObj={MapperTypeCompanyLevel}
					disabled={rest?.record || rest.defaultValue}
					defaultValue={rest.defaultValue}
					validate={required()}
				/>
				<GridInput xs={12} source="data" label="resources.mappers.fields.data">
					{isPredefined ? (
						<MapperDataInputPredefined
							requiredKeys={requiredKeys}
							formData={values}
							orderImportCustomFields={orderImportCustomFields}
						/>
					) : (
						<MapperDataInput />
					)}
				</GridInput>
				{values.type === MapperTypeCompanyLevel.order_import && rest.isAppRole && (
					<GridInput xs={12} source="settings" label="resources.mappers.fields.settings">
						<MapperSettingsInputPredefined formData={values} form={form} />
					</GridInput>
				)}
			</GridForm>
		</PassProps>
	);
};
